<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ this.pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">Settings</li>
                            <li class="breadcrumb-item active">{{ this.pageName }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.pageName }}</h4>
                </div>
                <div class="card-body">
                    <section class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Minimum IOS Version</label>
                                        <input type="text" required class="form-control"
                                               v-model="configuration.minimum_ios_version">
                                        <span v-if="configuration.errors.minimum_ios_version"
                                              class="text-danger text-small">{{
                                                configuration.errors.minimum_ios_version
                                            }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Minimum Android Version</label>
                                        <input type="text" required class="form-control"
                                               v-model="configuration.minimum_android_version">
                                        <span v-if="configuration.errors.minimum_android_version"
                                              class="text-danger text-small">{{
                                                configuration.errors.minimum_android_version
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Minimum Rider App Version</label>
                                        <input type="text" required class="form-control"
                                               v-model="configuration.minimum_rider_app_version">
                                        <span v-if="configuration.errors.minimum_rider_app_version"
                                              class="text-danger text-small">{{
                                                configuration.errors.minimum_rider_app_version
                                            }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Rider App Download Link</label>
                                        <input type="text" required class="form-control"
                                               v-model="configuration.rider_app_download_location">
                                        <span v-if="configuration.errors.rider_app_download_location"
                                              class="text-danger text-small">{{
                                                configuration.errors.rider_app_download_location
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary" @click="updateAppCompatibilitySettings">
                                    Update
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import QuillEditor from '../../Shared/QuillEditor';
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Configurations'},
    props: [
        'configurations',
        'configurationEnums',
        'pageName',
        'routeName',
    ],
    layout: Layout,
    name: 'ConfigurationIndex',
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            saving: false,
            configuration: this.$inertia.form({
                minimum_android_version: null,
                minimum_ios_version: null,
                minimum_rider_app_version: null,
                rider_app_download_location: null,
            }),
        };
    },

    mounted() {
        this.configuration.minimum_android_version = this.configurations.minimum_android_version;
        this.configuration.minimum_ios_version = this.configurations.minimum_ios_version;
        this.configuration.rider_app_download_location = this.configurations.rider_app_download_location;
        this.configuration.minimum_rider_app_version = this.configurations.minimum_rider_app_version;
    },

    methods: {
        async updateAppCompatibilitySettings() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.configuration.post(route(this.routeName), options);
            this.saving = false;
        },
    }
}
</script>
